import * as f from "./fields";
import { ConsultantContractType, Professions } from "@bonliva-crm/shared";

export const defaultFields = [f.contractType, f.profession];
export const intermittentBase = [f.contractType, f.profession, f.startDate, f.endDate];

const outsourceBase = [
  ...defaultFields,
  f.customerSelector,
  f.departmentSelect,
  f.address,
  f.period,
  f.startDate,
  f.endDate
];

const confirmationBase = [
  f.professionDisabled,
  f.customerSelector,
  f.departmentSelect,
  f.address,
  f.period
];

const confirmationBase_national = [
  f.professionDisabled,
  f.customerSelector,
  f.departmentSelect_national,
  f.address_national,
  f.period
];

const confirmationBaseBC = [
  f.professionDisabled,
  f.customerSelector,
  f.departmentSelect,
  f.period
];

const confirmationForEmployeesBase = [
  f.professionDisabled,
  f.customerSelector,
  f.departmentSelect,
  f.period
];

const confirmationForEmployeesBase_national = [
  f.professionDisabled,
  f.customerSelector,
  f.departmentSelect_national,
  f.period
];

const SalaryAccTravel = [
  f.salaryChoice,
  f.pricesRecords,
  f.bonusRecords,
  f.accommodation,
  f.travels
];

const SalaryAccTravelPsycolog = [
  f.pricesRecords,
  f.bonusRecords,
  f.notRelevantMonthlyWeeklyPayouts,
  // f.overtime,
  f.accommodation,
  f.travels
];

const SalaryAccTravelSub = [
  // f.overtime,
  f.pricesRecords,
  f.bonusRecords,
  { ...f.accommodation, schema: f.accSubSchema },
  { ...f.travels, schema: f.travelsSubSchema }
];

const SalaryAccTravelSubBC = [
  f.consultantGetsPaidPer,
  f.pricesRecords,
  // will add it later
  // f.bonusRecords,
  { ...f.accommodation, schema: f.accSubSchemaBC },
  { ...f.travels, schema: f.travelsSubSchemaBC }
];

const SalaryAccTravelBC = [
  f.consultantGetsPaidPer,
  f.pricesRecords,
  // will add it later
  // f.bonusRecords,
  { ...f.accommodation, schema: f.accSchemaBC },
  { ...f.travels, schema: f.travelsSchemaBC }
];

type ContractSchemaType = {
  [key in ConsultantContractType]: {
    [profession in Professions]?: typeof defaultFields | [];
  };
};

export const contracts: ContractSchemaType = {
  [ConsultantContractType.Outsource]: {
    [Professions.SE_LAKARE]: [
      ...outsourceBase,
      f.patientVisits,
      f.otherRequirements,
      f.experienceYears,
      f.areaOfExpertise,
      f.language,
      f.specificRequirements,
      ...SalaryAccTravelSub
    ],
    [Professions.SE_SSK]: [
      ...outsourceBase,
      f.otherRequirements,
      f.experienceYears,
      f.areaOfExpertise,
      f.language,
      f.education,
      f.driverLicense,
      f.specificRequirements,
      f.overtime,
      ...SalaryAccTravelSub
    ],
    [Professions.SE_BARNMORSKA]: [
      ...outsourceBase,
      f.otherRequirements,
      f.experienceYears,
      f.areaOfExpertise,
      f.language,
      f.education,
      f.driverLicense,
      f.specificRequirements,
      f.overtime,
      ...SalaryAccTravelSub
    ],
    [Professions.SE_RONTGENSJUKSKOTERSKA]: [
      ...outsourceBase,
      f.patientVisits,
      f.otherRequirements,
      f.experienceYears,
      f.areaOfExpertise,
      f.specializations,
      f.language,
      f.specificRequirements,
      ...SalaryAccTravelSub
    ],
    [Professions.SE_BIOMEDICINSK_ANALYTIKER]: [
      ...outsourceBase,
      f.otherRequirements,
      f.experienceYears,
      f.areaOfExpertise,
      f.specializations,
      f.language,
      f.specificRequirements,
      ...SalaryAccTravelSub
    ],
    [Professions.SE_ARBETSTERAPEUT]: [
      ...outsourceBase,
      f.otherRequirements,
      f.areaOfExpertise,
      f.language,
      f.education,
      f.driverLicense,
      f.specificRequirements,
      f.overtime,
      ...SalaryAccTravelSub
    ],
    [Professions.SE_FYSIOTERAPEUT]: [
      ...outsourceBase,
      f.otherRequirements,
      f.areaOfExpertise,
      f.language,
      f.education,
      f.driverLicense,
      f.specificRequirements,
      f.overtime,
      ...SalaryAccTravelSub
    ],
    [Professions.SE_PSYKOLOG]: [
      ...outsourceBase,
      f.notRelevantMonthlyWeeklyPayouts,
      f.otherRequirements,
      f.schedule,
      f.experienceYears,
      f.areaOfExpertise,
      f.specializations,
      f.language,
      f.specificRequirements,
      ...SalaryAccTravelSub
    ],
    [Professions.SE_SOCIONOM]: [
      ...outsourceBase,
      f.otherRequirements,
      f.schedule,
      f.experienceYears,
      f.areaOfExpertise,
      f.language,
      f.specificRequirements,
      ...SalaryAccTravelSub
    ],
    [Professions.SE_PSYKOTERAPEUT]: [
      ...outsourceBase,
      f.otherRequirements,
      f.schedule,
      f.experienceYears,
      f.areaOfExpertise,
      f.language,
      f.specificRequirements,
      ...SalaryAccTravelSub
    ],
    [Professions.SE_USK]: [
      ...outsourceBase,
      f.otherRequirements,
      f.areaOfExpertise,
      f.specializations,
      f.language,
      f.education,
      f.driverLicense,
      f.specificRequirements,
      ...SalaryAccTravelSub
    ],
    [Professions.SE_MEDICINSKA_SEKRETERARE]: [
      ...outsourceBase,
      f.otherRequirements,
      f.areaOfExpertise,
      f.language,
      f.driverLicense,
      f.specificRequirements,
      ...SalaryAccTravelSub
    ],
    [Professions.SE_AUDIONOM]: [...defaultFields],
    [Professions.SE_DIETIST]: [...defaultFields],
    [Professions.SE_FARMACEUTER]: [...defaultFields],
    [Professions.SE_INTERNREKRYTERING]: [...defaultFields],
    [Professions.SE_LARARE]: [...defaultFields]
  },
  [ConsultantContractType.Outsource_National]: {
    [Professions.SE_LAKARE]: [
      ...defaultFields,
      f.areaOfExpertise,
      f.customerSelector,
      f.departmentSelect_national,
      f.address_national,
      f.period,
      f.startDate,
      f.endDate,
      f.pensionSolution,
      f.patientVisits,
      f.otherRequirements,
      f.experienceYears,
      // f.language, hidden but default value is C1
      f.specificRequirements,
      ...SalaryAccTravelSub
    ],
    [Professions.SE_SSK]: [
      ...defaultFields,
      f.customerSelector,
      f.departmentSelect_national,
      f.address_national,
      f.period,
      f.startDate,
      f.endDate,
      f.pensionSolution,
      f.otherRequirements,
      f.experienceYears,
      f.areaOfExpertise,
      // f.language, hidden but default value is C1
      f.specificRequirements,
      // f.overtime,
      ...SalaryAccTravelSub
    ],
    [Professions.SE_BARNMORSKA]: [
      ...defaultFields,
      f.areaOfExpertise,
      f.customerSelector,
      f.departmentSelect_national,
      f.address_national,
      f.period,
      f.startDate,
      f.endDate,
      f.pensionSolution,
      f.otherRequirements,
      f.experienceYears,
      // f.language, hidden but default value is C1
      f.specificRequirements,
      // f.overtime,
      ...SalaryAccTravelSub
    ],
    [Professions.SE_RONTGENSJUKSKOTERSKA]: [
      ...defaultFields,
      f.areaOfExpertise,
      f.specializations,
      f.customerSelector,
      f.departmentSelect_national,
      f.address_national,
      f.period,
      f.startDate,
      f.endDate,
      f.pensionSolution,
      f.patientVisits,
      f.otherRequirements,
      f.experienceYears,
      // f.language, hidden but default value is C1
      f.specificRequirements,
      ...SalaryAccTravelSub
    ]
  },
  [ConsultantContractType.Framework]: {
    [Professions.SE_LAKARE]: [
      ...defaultFields,
      f.startDate,
      f.endDate,
      f.areaOfExpertise,
      f.language,
      f.otherRequirements,
      ...SalaryAccTravelSub
      // f.dateFrameworkContractTypeIsSigned
    ],
    [Professions.SE_SSK]: [
      ...defaultFields,
      f.startDate,
      f.endDate,
      f.areaOfExpertise,
      f.language,
      f.education,
      f.driverLicense,
      f.otherRequirements,
      ...SalaryAccTravelSub
    ],
    [Professions.SE_BARNMORSKA]: [
      ...defaultFields,
      f.startDate,
      f.endDate,
      f.areaOfExpertise,
      f.language,
      f.education,
      f.driverLicense,
      f.otherRequirements,
      ...SalaryAccTravelSub
    ],
    [Professions.SE_RONTGENSJUKSKOTERSKA]: [
      ...defaultFields,
      f.startDate,
      f.endDate,
      f.areaOfExpertise,
      f.specializations,
      f.language,
      f.otherRequirements,
      ...SalaryAccTravelSub
    ],
    [Professions.SE_ARBETSTERAPEUT]: [
      ...defaultFields,
      f.startDate,
      f.endDate,
      f.areaOfExpertise,
      f.language,
      f.education,
      f.driverLicense,
      f.otherRequirements,
      ...SalaryAccTravelSub
    ],
    [Professions.SE_FYSIOTERAPEUT]: [
      ...defaultFields,
      f.startDate,
      f.endDate,
      f.areaOfExpertise,
      f.language,
      f.education,
      f.driverLicense,
      f.otherRequirements,
      ...SalaryAccTravelSub
    ],
    [Professions.SE_PSYKOLOG]: [
      ...defaultFields,
      f.startDate,
      f.endDate,
      f.areaOfExpertise,
      f.specializations,
      f.language,
      f.otherRequirements,
      ...SalaryAccTravelSub
    ],
    [Professions.SE_SOCIONOM]: [
      ...defaultFields,
      f.startDate,
      f.endDate,
      f.areaOfExpertise,
      f.otherRequirements,
      f.language,
      ...SalaryAccTravelSub
    ],
    [Professions.SE_PSYKOTERAPEUT]: [
      ...defaultFields,
      f.startDate,
      f.endDate,
      f.language,
      ...SalaryAccTravelSub
    ],
    [Professions.SE_USK]: [...defaultFields, f.startDate, f.endDate],
    [Professions.SE_MEDICINSKA_SEKRETERARE]: [
      ...defaultFields,
      f.startDate,
      f.endDate,
      f.areaOfExpertise,
      f.otherRequirements,
      f.language,
      f.driverLicense,
      ...SalaryAccTravelSub
    ],
    [Professions.SE_AUDIONOM]: [...defaultFields, f.startDate, f.endDate],
    [Professions.SE_BIOMEDICINSK_ANALYTIKER]: [
      ...defaultFields,
      f.startDate,
      f.endDate,
      f.areaOfExpertise,
      f.specializations,
      f.language,
      f.otherRequirements,
      ...SalaryAccTravelSub
    ],
    [Professions.SE_DIETIST]: [...defaultFields, f.startDate, f.endDate],
    [Professions.SE_FARMACEUTER]: [...defaultFields, f.startDate, f.endDate],
    [Professions.SE_INTERNREKRYTERING]: [...defaultFields, f.startDate, f.endDate],
    [Professions.SE_LARARE]: [...defaultFields, f.startDate, f.endDate]
  },
  [ConsultantContractType.Framework_National]: {
    [Professions.SE_LAKARE]: [
      ...defaultFields,
      f.areaOfExpertise,
      f.startDate,
      f.endDate,
      f.pensionSolution,
      f.experienceYears,
      // f.language, hidden but default value is C1
      f.otherRequirements,
      ...SalaryAccTravelSub
      // f.dateFrameworkContractTypeIsSigned
    ],
    [Professions.SE_SSK]: [
      ...defaultFields,
      f.areaOfExpertise,
      f.startDate,
      f.endDate,
      f.pensionSolution,
      f.experienceYears,
      // f.language, hidden but default value is C1
      f.otherRequirements,
      ...SalaryAccTravelSub
    ],
    [Professions.SE_BARNMORSKA]: [
      ...defaultFields,
      f.areaOfExpertise,
      f.startDate,
      f.endDate,
      f.pensionSolution,
      f.experienceYears,
      // f.language, hidden but default value is C1
      f.otherRequirements,
      ...SalaryAccTravelSub
    ],
    [Professions.SE_RONTGENSJUKSKOTERSKA]: [
      ...defaultFields,
      f.areaOfExpertise,
      f.specializations,
      f.startDate,
      f.endDate,
      f.pensionSolution,
      f.experienceYears,
      // f.language, hidden but default value is C1
      f.otherRequirements,
      ...SalaryAccTravelSub
    ]
  },
  [ConsultantContractType.Confirmation]: {
    [Professions.SE_LAKARE]: [
      ...confirmationBase,
      f.pricesRecords,
      f.bonusRecords,
      f.dateFrameworkContractTypeIsSigned
    ],
    [Professions.SE_SSK]: [
      ...confirmationBase,
      f.specificRequirements,
      f.pricesRecords,
      f.bonusRecords,
      f.overtime,
      f.dateFrameworkContractTypeIsSigned
    ],
    [Professions.SE_BARNMORSKA]: [
      ...confirmationBase,
      f.specificRequirements,
      f.pricesRecords,
      f.bonusRecords,
      f.overtime,
      f.dateFrameworkContractTypeIsSigned
    ],
    [Professions.SE_RONTGENSJUKSKOTERSKA]: [
      ...confirmationBase,
      f.specificRequirements,
      f.pricesRecords,
      f.bonusRecords,
      f.dateFrameworkContractTypeIsSigned
    ],
    [Professions.SE_BIOMEDICINSK_ANALYTIKER]: [
      ...confirmationBase,
      f.specificRequirements,
      f.pricesRecords,
      f.bonusRecords,
      f.dateFrameworkContractTypeIsSigned
    ],
    [Professions.SE_ARBETSTERAPEUT]: [
      ...confirmationBase,
      f.specificRequirements,
      f.pricesRecords,
      f.bonusRecords,
      f.overtime,
      f.dateFrameworkContractTypeIsSigned
    ],
    [Professions.SE_FYSIOTERAPEUT]: [
      ...confirmationBase,
      f.specificRequirements,
      f.pricesRecords,
      f.bonusRecords,
      f.overtime,
      f.dateFrameworkContractTypeIsSigned
    ],
    [Professions.SE_PSYKOLOG]: [
      ...confirmationBase,
      f.schedule,
      f.specificRequirements,
      f.pricesRecords,
      f.bonusRecords,
      f.dateFrameworkContractTypeIsSigned
    ],
    [Professions.SE_SOCIONOM]: [
      ...confirmationBase,
      f.schedule,
      f.specificRequirements,
      f.pricesRecords,
      f.bonusRecords,
      f.dateFrameworkContractTypeIsSigned
    ],
    [Professions.SE_PSYKOTERAPEUT]: [
      ...confirmationBase,
      f.schedule,
      f.specificRequirements,
      f.pricesRecords,
      f.bonusRecords,
      f.dateFrameworkContractTypeIsSigned
    ],
    [Professions.SE_USK]: [
      ...confirmationBase,
      f.areaOfExpertise,
      f.specializations,
      f.otherRequirements,
      f.language,
      f.education,
      f.driverLicense,
      ...SalaryAccTravelSub,
      f.dateFrameworkContractTypeIsSigned
    ],
    [Professions.SE_MEDICINSKA_SEKRETERARE]: [
      ...confirmationBase,
      f.specificRequirements,
      f.pricesRecords,
      f.bonusRecords,
      f.dateFrameworkContractTypeIsSigned
    ],
    //
    [Professions.SE_AUDIONOM]: [],
    [Professions.SE_DIETIST]: [],
    [Professions.SE_FARMACEUTER]: [],
    [Professions.SE_INTERNREKRYTERING]: [],
    [Professions.SE_LARARE]: []
  },
  [ConsultantContractType.Confirmation_National]: {
    [Professions.SE_LAKARE]: [
      ...confirmationBase_national,
      f.pricesRecords,
      f.bonusRecords,
      f.dateFrameworkContractTypeIsSigned,
      f.nationalProcurementPriceStrategy
    ],
    [Professions.SE_SSK]: [
      ...confirmationBase_national,
      f.specificRequirements,
      f.pricesRecords,
      f.bonusRecords,
      f.overtime,
      f.dateFrameworkContractTypeIsSigned,
      f.nationalProcurementPriceStrategy
    ],
    [Professions.SE_BARNMORSKA]: [
      ...confirmationBase_national,
      f.specificRequirements,
      f.pricesRecords,
      f.bonusRecords,
      f.overtime,
      f.dateFrameworkContractTypeIsSigned,
      f.nationalProcurementPriceStrategy
    ],
    [Professions.SE_RONTGENSJUKSKOTERSKA]: [
      ...confirmationBase_national,
      f.specificRequirements,
      f.pricesRecords,
      f.bonusRecords,
      f.dateFrameworkContractTypeIsSigned,
      f.nationalProcurementPriceStrategy
    ]
  },
  [ConsultantContractType.Employment]: {
    [Professions.SE_LAKARE]: [
      ...outsourceBase,
      f.country,
      f.areaOfExpertise,
      f.patientVisits,
      f.otherRequirements,
      f.experienceYears,
      f.language,
      f.specificRequirements,
      ...SalaryAccTravel
    ],
    [Professions.SE_SSK]: [
      ...outsourceBase,
      f.country,
      f.areaOfExpertise,
      f.otherRequirements,
      f.experienceYears,
      f.language,
      f.education,
      f.driverLicense,
      f.specificRequirements,
      f.overtime,
      ...SalaryAccTravel
    ],
    [Professions.SE_BARNMORSKA]: [
      ...outsourceBase,
      f.country,
      f.areaOfExpertise,
      f.otherRequirements,
      f.experienceYears,
      f.language,
      f.education,
      f.driverLicense,
      f.specificRequirements,
      f.overtime,
      ...SalaryAccTravel
    ],
    [Professions.SE_RONTGENSJUKSKOTERSKA]: [
      ...outsourceBase,
      f.patientVisits,
      f.specializations,
      f.otherRequirements,
      f.experienceYears,
      f.language,
      f.specificRequirements,
      ...SalaryAccTravel
    ],
    [Professions.SE_BIOMEDICINSK_ANALYTIKER]: [
      ...outsourceBase,
      f.specializations,
      f.otherRequirements,
      f.experienceYears,
      f.language,
      f.specificRequirements,
      ...SalaryAccTravel
    ],
    [Professions.SE_ARBETSTERAPEUT]: [
      ...outsourceBase,
      f.otherRequirements,
      f.language,
      f.education,
      f.driverLicense,
      f.specificRequirements,
      f.overtime,
      ...SalaryAccTravel
    ],
    [Professions.SE_FYSIOTERAPEUT]: [
      ...outsourceBase,
      f.otherRequirements,
      f.language,
      f.education,
      f.driverLicense,
      f.specificRequirements,
      f.overtime,
      ...SalaryAccTravel
    ],
    [Professions.SE_PSYKOLOG]: [
      ...outsourceBase,
      f.schedule,
      f.specializations,
      f.otherRequirements,
      f.experienceYears,
      f.language,
      f.specificRequirements,
      ...SalaryAccTravelPsycolog
    ],
    [Professions.SE_SOCIONOM]: [
      ...outsourceBase,
      f.areaOfExpertise,
      f.schedule,
      f.otherRequirements,
      f.experienceYears,
      f.language,
      f.specificRequirements,
      ...SalaryAccTravel
    ],
    [Professions.SE_PSYKOTERAPEUT]: [
      ...outsourceBase,
      f.schedule,
      f.otherRequirements,
      f.experienceYears,
      f.language,
      f.specificRequirements,
      ...SalaryAccTravel
    ],
    [Professions.SE_USK]: [
      ...outsourceBase,
      f.areaOfExpertise,
      f.specializations,
      f.otherRequirements,
      f.language,
      f.education,
      f.driverLicense,
      f.specificRequirements,
      ...SalaryAccTravel
    ],
    [Professions.SE_MEDICINSKA_SEKRETERARE]: [
      ...outsourceBase,
      f.otherRequirements,
      f.language,
      f.driverLicense,
      f.specificRequirements,
      ...SalaryAccTravel
    ],
    [Professions.SE_AUDIONOM]: [...defaultFields],
    [Professions.SE_DIETIST]: [...defaultFields],
    [Professions.SE_FARMACEUTER]: [...defaultFields],
    [Professions.SE_INTERNREKRYTERING]: [...defaultFields],
    [Professions.SE_LARARE]: [...defaultFields]
  },
  [ConsultantContractType.Employment_National]: {
    [Professions.SE_LAKARE]: [
      ...defaultFields,
      f.customerSelector,
      f.departmentSelect_national,
      f.address_national,
      f.period,
      f.startDate,
      f.endDate,
      f.pensionSolution,
      // f.country, hidden but default value is Sweden
      f.areaOfExpertise,
      f.patientVisits,
      f.otherRequirements,
      f.experienceYears,
      // f.language, hidden but default value is C1
      f.specificRequirements,
      ...SalaryAccTravel
    ],
    [Professions.SE_SSK]: [
      ...defaultFields,
      f.areaOfExpertise,
      f.customerSelector,
      f.departmentSelect_national,
      f.address_national,
      f.period,
      f.startDate,
      f.endDate,
      f.pensionSolution,
      // f.country, hidden but default value is Sweden
      f.otherRequirements,
      f.experienceYears,
      // f.language, hidden but default value is C1
      f.specificRequirements,
      // f.overtime,
      ...SalaryAccTravel
    ],
    [Professions.SE_BARNMORSKA]: [
      ...defaultFields,
      f.areaOfExpertise,
      f.customerSelector,
      f.departmentSelect_national,
      f.address_national,
      f.period,
      f.startDate,
      f.endDate,
      f.pensionSolution,
      // f.country, hidden but default value is Sweden
      f.otherRequirements,
      f.experienceYears,
      // f.language, hidden but default value is C1
      f.specificRequirements,
      // f.overtime,
      ...SalaryAccTravel
    ],
    [Professions.SE_RONTGENSJUKSKOTERSKA]: [
      ...defaultFields,
      f.specializations,
      f.customerSelector,
      f.departmentSelect_national,
      f.address_national,
      f.period,
      f.startDate,
      f.endDate,
      f.pensionSolution,
      f.patientVisits,
      f.otherRequirements,
      f.experienceYears,
      // f.language, hidden but default value is C1
      f.specificRequirements,
      ...SalaryAccTravel
    ]
  },
  [ConsultantContractType.Intermittent]: {
    [Professions.SE_LAKARE]: [
      f.contractType,
      f.profession,
      f.startDate,
      f.endDate,
      f.country,
      f.areaOfExpertise,
      f.language,
      f.specificRequirements,
      ...SalaryAccTravel
    ],
    [Professions.SE_SSK]: [
      f.contractType,
      f.profession,
      f.startDate,
      f.endDate,
      f.country,
      f.areaOfExpertise,
      f.language,
      f.education,
      f.driverLicense,
      f.specificRequirements,
      f.overtime,
      ...SalaryAccTravel
    ],
    [Professions.SE_BARNMORSKA]: [
      f.contractType,
      f.profession,
      f.startDate,
      f.endDate,
      f.country,
      f.areaOfExpertise,
      f.language,
      f.education,
      f.driverLicense,
      f.specificRequirements,
      f.overtime,
      ...SalaryAccTravel
    ],
    [Professions.SE_RONTGENSJUKSKOTERSKA]: [
      f.contractType,
      f.profession,
      f.startDate,
      f.endDate,
      f.areaOfExpertise,
      f.specializations,
      f.patientVisits,
      f.language,
      f.specificRequirements,
      ...SalaryAccTravel
    ],
    [Professions.SE_BIOMEDICINSK_ANALYTIKER]: [
      f.contractType,
      f.profession,
      f.startDate,
      f.endDate,
      f.areaOfExpertise,
      f.specializations,
      f.language,
      f.specificRequirements,
      ...SalaryAccTravel
    ],
    [Professions.SE_ARBETSTERAPEUT]: [
      f.contractType,
      f.profession,
      f.startDate,
      f.endDate,
      f.areaOfExpertise,
      f.language,
      f.education,
      f.driverLicense,
      f.specificRequirements,
      f.overtime,
      ...SalaryAccTravel
    ],
    [Professions.SE_FYSIOTERAPEUT]: [
      f.contractType,
      f.profession,
      f.startDate,
      f.endDate,
      f.areaOfExpertise,
      f.language,
      f.education,
      f.driverLicense,
      f.specificRequirements,
      f.overtime,
      ...SalaryAccTravel
    ],
    [Professions.SE_PSYKOLOG]: [
      f.contractType,
      f.profession,
      f.startDate,
      f.endDate,
      f.notRelevantMonthlyWeeklyPayouts,
      f.areaOfExpertise,
      f.specializations,
      f.language,
      f.specificRequirements,
      ...SalaryAccTravel
    ],
    [Professions.SE_SOCIONOM]: [
      f.contractType,
      f.profession,
      f.startDate,
      f.endDate,
      f.areaOfExpertise,
      f.language,
      f.specificRequirements,
      ...SalaryAccTravel
    ],
    [Professions.SE_PSYKOTERAPEUT]: [
      f.contractType,
      f.profession,
      f.startDate,
      f.endDate,
      f.areaOfExpertise,
      f.language,
      f.specificRequirements,
      ...SalaryAccTravel
    ],
    [Professions.SE_USK]: [
      f.contractType,
      f.profession,
      f.startDate,
      f.endDate,
      f.areaOfExpertise,
      f.specializations,
      f.language,
      f.education,
      f.driverLicense,
      f.specificRequirements,
      ...SalaryAccTravel
    ],
    [Professions.SE_MEDICINSKA_SEKRETERARE]: [
      f.contractType,
      f.profession,
      f.startDate,
      f.endDate,
      f.areaOfExpertise,
      f.language,
      f.driverLicense,
      f.specificRequirements,
      ...SalaryAccTravel
    ],
    [Professions.SE_AUDIONOM]: [],
    [Professions.SE_DIETIST]: [],
    [Professions.SE_FARMACEUTER]: [],
    [Professions.SE_INTERNREKRYTERING]: [],
    [Professions.SE_LARARE]: []
  },
  [ConsultantContractType.Intermittent_National]: {
    [Professions.SE_LAKARE]: [
      f.contractType,
      f.profession,
      f.areaOfExpertise,
      f.startDate,
      f.endDate,
      f.pensionSolution,
      f.experienceYears,
      // f.country, default value is Sweden
      // f.language, default value is C1
      f.specificRequirements,
      ...SalaryAccTravel
    ],
    [Professions.SE_SSK]: [
      f.contractType,
      f.profession,
      f.startDate,
      f.endDate,
      f.pensionSolution,
      f.experienceYears,
      // f.country, default value is Sweden
      f.areaOfExpertise,
      // f.language, default value is C1
      f.specificRequirements,
      f.overtime,
      ...SalaryAccTravel
    ],
    [Professions.SE_BARNMORSKA]: [
      f.contractType,
      f.profession,
      f.areaOfExpertise,
      f.startDate,
      f.endDate,
      f.pensionSolution,
      f.experienceYears,
      // f.country, default value is Sweden
      // f.language,
      f.specificRequirements,
      f.overtime,
      ...SalaryAccTravel
    ],
    [Professions.SE_RONTGENSJUKSKOTERSKA]: [
      f.contractType,
      f.profession,
      f.areaOfExpertise,
      f.specializations,
      f.startDate,
      f.endDate,
      f.pensionSolution,
      f.experienceYears,
      f.patientVisits,
      // f.language,
      f.specificRequirements,
      ...SalaryAccTravel
    ]
  },
  [ConsultantContractType.ConfirmationForEmployees]: {
    [Professions.SE_LAKARE]: [
      ...confirmationForEmployeesBase,
      f.specificRequirementsBConfirmationEmp,
      f.pricesRecords,
      f.bonusRecords,
      f.dateFrameworkContractTypeIsSigned
    ],
    [Professions.SE_SSK]: [
      ...confirmationForEmployeesBase,
      f.specificRequirementsBConfirmationEmp,
      f.pricesRecords,
      f.bonusRecords,
      f.dateFrameworkContractTypeIsSigned
    ],
    [Professions.SE_BARNMORSKA]: [
      ...confirmationForEmployeesBase,
      f.specificRequirementsBConfirmationEmp,
      f.pricesRecords,
      f.bonusRecords,
      f.dateFrameworkContractTypeIsSigned
    ],
    [Professions.SE_RONTGENSJUKSKOTERSKA]: [
      ...confirmationForEmployeesBase,
      f.specificRequirementsBConfirmationEmp,
      f.pricesRecords,
      f.bonusRecords,
      f.dateFrameworkContractTypeIsSigned
    ],
    [Professions.SE_BIOMEDICINSK_ANALYTIKER]: [
      ...confirmationForEmployeesBase,
      f.specificRequirementsBConfirmationEmp,
      f.pricesRecords,
      f.bonusRecords,
      f.dateFrameworkContractTypeIsSigned
    ],
    [Professions.SE_ARBETSTERAPEUT]: [
      ...confirmationForEmployeesBase,
      f.specificRequirementsBConfirmationEmp,
      f.pricesRecords,
      f.bonusRecords,
      f.dateFrameworkContractTypeIsSigned
    ],
    [Professions.SE_FYSIOTERAPEUT]: [
      ...confirmationForEmployeesBase,
      f.specificRequirementsBConfirmationEmp,
      f.pricesRecords,
      f.bonusRecords,
      f.dateFrameworkContractTypeIsSigned
    ],
    [Professions.SE_PSYKOLOG]: [
      ...confirmationForEmployeesBase,
      f.specificRequirementsBConfirmationEmp,
      f.pricesRecords,
      f.bonusRecords,
      f.dateFrameworkContractTypeIsSigned
    ],
    [Professions.SE_SOCIONOM]: [
      ...confirmationForEmployeesBase,
      f.specificRequirementsBConfirmationEmp,
      f.pricesRecords,
      f.bonusRecords,
      f.dateFrameworkContractTypeIsSigned
    ],
    [Professions.SE_PSYKOTERAPEUT]: [
      ...confirmationForEmployeesBase,
      f.specificRequirementsBConfirmationEmp,
      f.pricesRecords,
      f.bonusRecords,
      f.dateFrameworkContractTypeIsSigned
    ],
    [Professions.SE_USK]: [
      ...confirmationForEmployeesBase,
      f.specificRequirementsBConfirmationEmp,
      f.pricesRecords,
      f.bonusRecords,
      f.dateFrameworkContractTypeIsSigned
    ],
    [Professions.SE_MEDICINSKA_SEKRETERARE]: [
      ...confirmationForEmployeesBase,
      f.specificRequirementsBConfirmationEmp,
      f.pricesRecords,
      f.bonusRecords,
      f.dateFrameworkContractTypeIsSigned
    ],
    [Professions.SE_AUDIONOM]: [],
    [Professions.SE_DIETIST]: [],
    [Professions.SE_FARMACEUTER]: [],
    [Professions.SE_INTERNREKRYTERING]: [],
    [Professions.SE_LARARE]: []
  },
  [ConsultantContractType.ConfirmationForEmployees_National]: {
    [Professions.SE_LAKARE]: [
      ...confirmationForEmployeesBase_national,
      f.specificRequirementsBConfirmationEmp,
      f.pricesRecords,
      f.bonusRecords,
      f.dateFrameworkContractTypeIsSigned,
      f.nationalProcurementPriceStrategy
    ],
    [Professions.SE_SSK]: [
      ...confirmationForEmployeesBase_national,
      f.specificRequirementsBConfirmationEmp,
      f.pricesRecords,
      f.bonusRecords,
      f.dateFrameworkContractTypeIsSigned,
      f.nationalProcurementPriceStrategy
    ],
    [Professions.SE_BARNMORSKA]: [
      ...confirmationForEmployeesBase_national,
      f.specificRequirementsBConfirmationEmp,
      f.pricesRecords,
      f.bonusRecords,
      f.dateFrameworkContractTypeIsSigned,
      f.nationalProcurementPriceStrategy
    ],
    [Professions.SE_RONTGENSJUKSKOTERSKA]: [
      ...confirmationForEmployeesBase_national,
      f.specificRequirementsBConfirmationEmp,
      f.pricesRecords,
      f.bonusRecords,
      f.dateFrameworkContractTypeIsSigned,
      f.nationalProcurementPriceStrategy
    ]
  },

  [ConsultantContractType.BC_Intermittent]: {
    [Professions.SE_LAKARE]: [
      ...defaultFields,
      { ...f.areaOfExpertise, xs: 12 },
      f.startDate,
      f.endDate,
      f.investigationsNumber,
      f.otherRequirements,
      // ...SalaryAccTravelBC // could be added later
      { ...f.accommodation, schema: f.accSchemaBC },
      { ...f.travels, schema: f.travelsSchemaBC }
    ],
    [Professions.SE_PSYKOLOG]: [
      ...defaultFields,
      f.areaOfExpertise,
      f.specializations,
      f.startDate,
      f.endDate,
      f.investigationsNumber,
      f.otherRequirements,
      // ...SalaryAccTravelBC // could be added later
      { ...f.accommodation, schema: f.accSchemaBC },
      { ...f.travels, schema: f.travelsSchemaBC }
    ]
  },
  [ConsultantContractType.BC_Framework]: {
    [Professions.SE_LAKARE]: [
      ...defaultFields,
      { ...f.areaOfExpertise, xs: 12 },
      f.startDate,
      f.endDate,
      f.isRegionDalarna,
      f.investigationsNumber,
      f.otherRequirements,
      // ...SalaryAccTravelSubBC // could be added later
      { ...f.accommodation, schema: f.accSubSchemaBC },
      { ...f.travels, schema: f.travelsSubSchemaBC }
    ],
    [Professions.SE_PSYKOLOG]: [
      ...defaultFields,
      f.areaOfExpertise,
      f.specializations,
      f.isRegionDalarna,
      f.startDate,
      f.endDate,
      f.investigationsNumber,
      f.otherRequirements,
      // ...SalaryAccTravelSubBC // could be added later
      { ...f.accommodation, schema: f.accSubSchemaBC },
      { ...f.travels, schema: f.travelsSubSchemaBC }
    ]
  },

  [ConsultantContractType.BC_Framework_Confirmation]: {
    [Professions.SE_LAKARE]: [
      ...confirmationBaseBC,
      ...SalaryAccTravelSubBC,
      f.dateFrameworkContractTypeIsSigned
    ],
    [Professions.SE_PSYKOLOG]: [
      ...confirmationBaseBC,
      ...SalaryAccTravelSubBC,
      f.dateFrameworkContractTypeIsSigned
    ]
  },
  [ConsultantContractType.BC_Intermittent_Confirmation]: {
    [Professions.SE_LAKARE]: [
      ...confirmationBaseBC,
      f.investigationsNumber,
      ...SalaryAccTravelBC,
      f.dateFrameworkContractTypeIsSigned
    ],
    [Professions.SE_PSYKOLOG]: [
      ...confirmationBaseBC,
      f.investigationsNumber,
      ...SalaryAccTravelBC,
      f.dateFrameworkContractTypeIsSigned
    ]
  },
  [ConsultantContractType.SelfInvoicing]: {

  }
};
// "Audionom",
// "Biomedicinsk analytiker",
// "Dietist",
// "Farmaceuter",
// "Internrekrytering",
// "Lärare",
export const bc_professions = ["Läkare", "Psykolog"];
export const national_professions = [
  "Läkare",
  "SSK",
  "Röntgensjuksköterska",
  "Barnmorska"
];
